// extracted by mini-css-extract-plugin
export default {"select":"CompanySelector_select__qOJCQ","option-container":"CompanySelector_option-container__rpB9-","item":"CompanySelector_item__tVjYN"};